import React from 'react';
import { Box, MenuItem, Select, Tab, Tabs, Tooltip, Typography } from '@mui/material';
import { TabsHeaderProps } from './TabsHeader.props';
import './TabsHeader.css';
import './styles/mobile.css';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  isMainBox: boolean;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, isMainBox, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && (
        <Box className={`tabpanel-${isMainBox ? 'main-box' : 'box'}`}>{children}</Box>
      )}
    </div>
  );
}

export const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
};

export const TabsHeader: React.FC<TabsHeaderProps> = ({
  defaultValue,
  data = [],
  onChange,
  isDropdown,
  onClick,
  renderTabs,
  isMainBox = false,
  labelBox = '',
  messageTooltipBox = '',
  className = ''
}) => {
  const [value, setValue] = React.useState(defaultValue);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    onChange && onChange(newValue);
  };

  const options = data?.map((obj, index) => ({
    label: obj.label,
    value: index
  }));

  const MobileDropdown: React.FC = () => (
    <Box
      display="flex"
      justifyContent="center"
      padding="21px 0px 13px"
      borderBottom="2px #E0E0E0 solid">
      <Select
        value={value}
        onChange={(event) => setValue(event.target.value)}
        variant="standard"
        className="mobile-dropdown"
        data-testid="tab-mobile-dropdown">
        {options?.map((option, index: number) => (
          <MenuItem
            data-testid="item-mobile-dropdown"
            key={option.value + index}
            value={option.value}
            onClick={() => onClick?.(option.value)}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );

  const DefaultTab: React.FC = () => (
    <Box className={`main-tabs-header-box ${isMainBox ? '' : 'main-tabs-header-box-courses'}` }>
      <Box className={`tabs-header-box ${isMainBox ? 'tabs-header-box-main-box' : ''}`}>
        {renderTabs?.({ data, handleChange, value }) ?? (
          <Tabs
            data-testid="header-tab"
            className={'tabs-header-box-tabs'}
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example">
            {data.map((item: any, index: number) => (
              <Tab
                key={index}
                label={
                  <span className="tab-label">
                    {item?.label}
                    {Number.isInteger(item?.number) && (
                      <span className="tab-notification" data-testid={`tab-notification-${index}`}>
                        {item.number}
                      </span>
                    )}
                  </span>
                }
                onClick={() => onClick?.(index)}
                className={`${isMainBox ? 'tabs-header-course-list-tab' : 'tabs-header-tab'}`}
                // style={{minHeight:'auto'}}
                {...a11yProps(index)}
              />
            ))}
          </Tabs>
        )}
      </Box>
    </Box>
  );

  return (
    <Box className={`tabs-header ${className}`} sx={{width: '100%'}}>
      {isDropdown ? (
        <MobileDropdown />
      ) : isMainBox ? (
        <div className={'main-box-tabs-header'}>
          <Box width={'100%'} mb={'20px'}>
            <Box width={'100%'} display="flex" justifyContent="space-between">
              <Typography
                sx={{ fontFamily: 'Righteous', fontSize: 24, fontWeight: 400, color: '#193051' }}>
                {labelBox}
              </Typography>
              <Typography>
                <Tooltip
                  title={messageTooltipBox}
                  placement="top-start"
                  arrow
                  componentsProps={{
                    tooltip: {
                      sx: {
                        fontSize: '13px',
                        [`&.MuiTooltip-tooltipPlacementTop`]: {
                          maxWidth: 'fit-content'
                        }
                      }
                    }
                  }}>
                  <InfoOutlinedIcon
                    sx={{ position: 'relative', top: '4px', cursor: 'pointer' }}
                    fontSize={'medium'}
                    htmlColor={'#193051'}
                  />
                </Tooltip>
              </Typography>
            </Box>
            {/*<Box width={'100%'} display="flex" justifyContent="space-between">*/}
            {/*  <Typography sx={{*/}
            {/*    fontFamily: 'Montserrat',*/}
            {/*    fontSize: 16,*/}
            {/*    fontWeight: 500,*/}
            {/*    color: '#000000',*/}
            {/*    opacity: 0.6,*/}
            {/*    marginTop: '12px'*/}
            {/*  }}>*/}
            {/*    A timeline of your emails and training*/}
            {/*  </Typography>*/}
            {/*</Box>*/}
          </Box>
          <div className={'main-box-tabs-header-content'}>
            <DefaultTab />
          </div>
        </div>
      ) : (
        <DefaultTab />
      )}
      {data.map((item: any, index: number) => {
        return (
          <TabPanel key={index} value={value} index={index} isMainBox={isMainBox}>
            {item.component}
          </TabPanel>
        );
      })}
    </Box>
  );
};
